import { useState } from 'react'
import { useContacts } from '../../../../../hooks/useContacts'
import { SecondaryButton } from '../_shared/Buttons/SecondaryButton'
import { Emphasize } from '../_shared/Emphasize'
import { CustomSelect } from '../_shared/CustomSelect'
import { useMutation, useQueryClient } from 'react-query'
import { changeDriver } from '../../../../../api/api'
import { Loading } from '../_shared/Loading'

export function EditDriver({
  user,
  car,
  id,
  setShowEditDriver,
}: {
  user: any
  car: any
  id: any
  setShowEditDriver: any
}) {
  const queryClient = useQueryClient()
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const contactsData = useContacts()
  const currentDriver = {
    value: car.driverID,
    label: car.driverName,
  }

  const contacts = Array.from(
    new Map(
      //@ts-ignore
      contactsData.contacts?.map((contact) => [
        contact.id,
        {
          value: contact.id,
          label: contact.name,
        },
      ]),
    )
      .values()
      .filter(
        (contact: { value: any; label: string }) =>
          contact.value !== currentDriver.value,
      ),
  )

  const data = useMutation(
    ['changeDriver', id],
    () => changeDriver(id, newDriver),
    {
      onSuccess: () => {
        setIsLoading(false)
        setSuccess(true)
        queryClient.refetchQueries('car')
      },
      onMutate: () => {
        setIsLoading(true)
      },
    },
  )

  function submit() {
    if (newDriver === currentDriver.value) {
      return
    }
    data.mutate()
  }
  const [newDriver, setNewDriver] = useState(currentDriver)

  if (data.isError) {
    return (
      <div className="flex w-full items-center justify-center min-h-[200px] flex-col gap-6">
        <p className="text-center max-w-[40ch] leading-7">
          Noe gikk galt under oppdatering av fører. Prøv igjen senere eller
          kontakt Autoplan.
        </p>
        <SecondaryButton onClick={() => setShowEditDriver(false)}>
          Lukk vinduet
        </SecondaryButton>
      </div>
    )
  }
  if (isLoading) {
    return (
      <Loading>
        <p>Oppdaterer fører...</p>
      </Loading>
    )
  }

  if (success) {
    return (
      <div className="flex w-full items-center justify-center min-h-[200px] flex-col gap-6">
        <p className="text-xl">Føreren er oppdatert!</p>
        <SecondaryButton onClick={() => setShowEditDriver(false)}>
          Lukk vinduet
        </SecondaryButton>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-8 items-start">
      <div className="flex flex-col gap-4">
        <h3 className=" text-xl font-semibold">Registert fører</h3>
        <p>
          Du er i ferd med å bytte fører for
          <Emphasize> {car?.registrationNumber}</Emphasize>
        </p>
      </div>
      <div className="w-full">
        <CustomSelect
          id="driver"
          options={[currentDriver, ...contacts]}
          value={newDriver.value ?? newDriver}
          onChange={(e) => setNewDriver(e)}
          label="Førerprofil"
        />
      </div>
      <SecondaryButton onClick={() => submit()}>Lagre</SecondaryButton>
    </div>
  )
}
